var cov_kbycakkp4 = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/InputTitle/index.ts",
      hash = "f9309bbedda5631313b8b1a9261c75edd7d0a200",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/InputTitle/index.ts",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import InputTitle from './inputTitle';
export default InputTitle;